import '../scss/performance-report.scss';

document.querySelectorAll('.performance-report .progress').forEach( circle => {
    const radius = circle.r.baseVal.value
    const circumference = radius  * 2 * Math.PI
    circle.style.strokeDasharray = circumference

    const percent = circle.dataset.report
    const strokeDashoffset = circumference - (percent / 100) * circumference
    circle.style.strokeDashoffset = strokeDashoffset
    circle.animate([
        // keyframes
        { "strokeDashoffset": circumference },
        { "strokeDashoffset": strokeDashoffset }
      ], {
        // timing options
        duration: 1000,
        fill: 'forwards' 
      });
} )
